import {axiosInstanceUnauth} from "./setup/axiosInstance";
import ENDPOINTS from "./setup/constants";

const getConfigUI = async () => {
	return axiosInstanceUnauth.get(ENDPOINTS.config_ui)
		.then((res) => {
			return res.data;
		}).catch((error) => {
			console.error('Request Failed:', error.config);
			if (error.response) {
				console.error('Status:',  error.response.status);
				console.error('Data:',    error.response.data);
				console.error('Headers:', error.response.headers);
			} else {
				console.error('Error Message:', error.message);
			}
	
			return Promise.reject(error.response || error.message);
		})
};

const configUIAPI = {
	getConfigUI: getConfigUI
}

export default configUIAPI

